module.exports = __webpack_public_path__ + "images/emburse-professional-logo.71e412154a3f18fbb69f50c5031bc8af.svg";